<template>
    <kgr-form-scaffold
        :with-primary-buttons="false"
        @backBtnClicked="redirectToOverview"
    >
        <table
            class="kgr-table kgr-table--block kgr-table--striped printable"
        >
            <thead>
                <tr class="kgr-table__row">
                    <th
                        class="kgr-table__cell kgr-table__cell--headline"
                    >
                        {{ $t('Guthaben') }}
                    </th>
                    <th class="kgr-table__cell kgr-table__cell--headline">
                        {{ $t('Kategorie') }}
                    </th>
                    <th class="kgr-table__cell kgr-table__cell--headline">
                        {{ $t('Abteilung') }}
                    </th>
                    <th class="kgr-table__cell kgr-table__cell--headline">
                        {{ $t('Betrag') }}
                    </th>
                    <th class="kgr-table__cell kgr-table__cell--headline">
                        {{ $t('Verwendet') }}
                    </th>
                    <th class="kgr-table__cell kgr-table__cell--headline">
                        {{ $t('Verbleibend') }}
                    </th>
                    <th class="kgr-table__cell kgr-table__cell--headline">
                        {{ $t('Aktiviert') }}
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr v-if="loading">
                    <td
                        colspan="7"
                        style="text-align: center;"
                    >
                        <kgr-loader />
                    </td>
                </tr>
                <tr v-else-if="memberCredits.length === 0">
                    <td
                        colspan="7"
                        style="text-align: center;"
                    >
                        {{ $t('dataTable.noData') }}
                    </td>
                </tr>
                <template v-else>
                    <tr
                        v-for="credit in memberCredits"
                        :key="credit.id"
                        class="kgr-table__row"
                    >
                        <td class="kgr-table__cell">
                            {{ credit.name }}
                        </td>
                        <td class="kgr-table__cell">
                            {{ credit.categoryName }}
                        </td>
                        <td class="kgr-table__cell">
                            {{ credit.departmentName }}
                        </td>
                        <td class="kgr-table__cell">
                            {{ credit.total.toFixed(2) }}
                        </td>
                        <td class="kgr-table__cell">
                            {{ credit.used.toFixed(2) }}
                        </td>
                        <td class="kgr-table__cell">
                            {{ credit.remaining.toFixed(2) }}
                        </td>
                        <td class="kgr-table__cell">
                            {{ credit.activatedAt }}
                        </td>
                    </tr>
                </template>
                <tr
                    class="kgr-table__row kgr-text kgr-text--bold"
                >
                    <td class="kgr-table__cell">
                        {{ $t('Summen') }}
                    </td>
                    <td class="kgr-table__cell">
                    </td>
                    <td class="kgr-table__cell">
                    </td>
                    <td class="kgr-table__cell">
                        {{ totalSum.toFixed(2) }}
                    </td>
                    <td class="kgr-table__cell">
                        {{ usedSum.toFixed(2) }}
                    </td>
                    <td class="kgr-table__cell">
                        {{ remainingSum.toFixed(2) }}
                    </td>
                    <td class="kgr-table__cell">
                    </td>
                </tr>
            </tbody>
        </table>
    </kgr-form-scaffold>
</template>

<script>
import FormScaffold from '../../../components/common/form/FormScaffold';
import Loading from '../../../components/common/Loading.vue';
import MemberCreditRepository from '../../../js/repository/MemberCreditRepository';

export default {
    components: {
        'kgr-loader': Loading,
        'kgr-form-scaffold': FormScaffold,
    },
    props: {
        id: {
            type: Number,
            required: true,
        },
        clubId: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {
            loading: false,
            initialLoading: true,
            memberCredits: [],
        };
    },
    computed: {
        totalSum() {
            let sum = 0;
            this.memberCredits.forEach((memberCredit) => sum += memberCredit.total);
            return sum;
        },
        remainingSum() {
            let sum = 0;
            this.memberCredits.forEach((memberCredit) => sum += memberCredit.remaining);
            return sum;
        },
        usedSum() {
            let sum = 0;
            this.memberCredits.forEach((memberCredit) => sum += memberCredit.used);
            return sum;
        },
    },
    created() {
        this.loadMemberCredits();
    },
    methods: {
        loadMemberCredits() {
            this.loading = true;
            MemberCreditRepository
                .findByMember(this.id)
                .then((memberCredits) => {
                    this.memberCredits = memberCredits;
                    this.loading = false;
                    this.initialLoading = false;
                });
        },
        redirectToOverview() {
            window.location = `/backend/clubs/${this.clubId}/members`;
        },
    },
};
</script>
